import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { sharedStorage } from '../../../common/storage/storage';

type WaAuthStore = {
  authenticated: boolean;
  serverCommunicationErrorExists: boolean;
  setAuthenticated: (authenticated: boolean) => void;
};

export const useWaAuthStore = create<WaAuthStore>()(
  persist<WaAuthStore>(
    (set, _get) => ({
      authenticated: false,
      serverCommunicationErrorExists: false,
      setAuthenticated: (authenticated: boolean) => set({ authenticated }),
    }),
    {
      name: 'wa-auth',
      storage: createJSONStorage(() => sharedStorage),
    }
  )
);
